import React from "react";
import style from "./therapies.module.scss";
import laser from "./img/laser.webp";
import laser_md from "./img/laser_md.webp";
import laser_lg from "./img/laser_lg.webp";
import laser_xl from "./img/laser_xl.webp";

import laser_png from "./img/laser.png";
import laser_md_png from "./img/laser_md.png";
import laser_lg_png from "./img/laser_lg.png";
import laser_xl_png from "./img/laser_xl.png";

function Therapies() {

  return (
    <div className={style.therapies}>
      <div className={style.therapiesTop}/>
      <div className="container">

        <div className={style.therapiesLaserWrap}>
          <div className={`${style.therapiesLaserDo} ${style.therapiesLaserContent}`}>
            <h2 className={style.therapies__title}>What Laser and other Light Therapies do</h2>
            <ul>
              <li className={style.therapiesLaserContent__text}>Increase blood circulation</li>
              <li className={style.therapiesLaserContent__text}>Stimulate cell mitochondria and ATP</li>
              <li className={style.therapiesLaserContent__text}>Stimulate the body’s anti-inflammatory response</li>
              <li className={style.therapiesLaserContent__text}>Help regulate nerve activity to relieve pain   </li>
              <li className={style.therapiesLaserContent__text}>Jump-start cell repair process by stimulating fibroblasts, increasing phagocytosis and DNA synthesis</li>
              <li className={style.therapiesLaserContent__text}>Improve lymphatic system activity</li>
              <li className={style.therapiesLaserContent__text}>Stimulate tissue regeneration in wound healing</li>
            </ul>
          </div>

          <div className={style.therapiesLaser__imgWrap}>
            <picture>
              <source media="(min-width: 1140px)" srcSet={laser_xl} type="image/webp"/>
              <source media="(min-width: 1140px)" srcSet={laser_xl_png} type="image/png"/>

              <source media="(min-width: 960px)" srcSet={laser_lg} type="image/webp"/>
              <source media="(min-width: 960px)" srcSet={laser_lg_png} type="image/png"/>

              <source media="(min-width: 720px)" srcSet={laser_md} type="image/webp"/>
              <source media="(min-width: 720px)" srcSet={laser_md_png} type="image/png"/>

              <source media="(max-width: 719px)" srcSet={laser} type="image/webp"/>
              <img src={laser_png} alt="second acupuncture" width="289px" height="326px"/>
            </picture>
          </div>

          <div className={`${style.therapiesLaserHelp} ${style.therapiesLaserContent}`}>
            <h2 className={style.therapies__title}>Laser and LED Treatments help</h2>
            <ul>
              <li className={style.therapiesLaserContent__text}>Speed up post-trauma and post-surgery healing of inflammation, fractures, and wounds</li>
              <li className={style.therapiesLaserContent__text}>Improve skin conditions</li>
              <li className={style.therapiesLaserContent__text}>Help improve outcome and reduce pain pre and post dental procedures
              </li>
            </ul>
          </div>
        </div>

      </div>

      {/*ToDo: выяснить у дизайнера насчет нижнего фона на высоких резрешениях*/}
      {/*<div className={style.therapiesBottom}/>*/}
    </div>
  )
}

export default Therapies;